export const CST = {
	SCENES: {
		BOOT: 'BOOT',
		PRELOAD: 'PRELOAD',
		LANGUAGE: 'LANGUAGE',
		LOGIN: 'LOGIN',
		REGISTER_CHOOSE: 'REGISTER_CHOOSE',
		SIGNUP: 'SIGNUP',
		SIGNUP_ORG: 'SIGNUP_ORG',
		RESETPASSWORD: 'RESETPASSWORD',
		SENDEMAIL: 'SENDEMAIL',
		VERIFY2FA: 'VERIFY2FA',
		LICENSEEXPIRED: 'LICENSEEXPIRED',
		MENU: 'MENU',
		TIME: 'TIME',
		CATEGORYSELECTION: 'CATEGORYSELECTION',
		INTRO: 'INTRO',
		BOARD: 'BOARD',
		BOARDONLYVIEW: 'BOARDONLYVIEW',
		RULES1: 'RULES1',
		TESTIMONIAL: 'TESTIMONIAL',
		ENDSCREEN: 'ENDSCREEN',
		ENDSCREENCLIENT: 'ENDSCREENCLIENT',
	},
	TEXTSTYLES: {
		TITLESTYLE: {
			fontFamily: 'Arial',
			fontSize: '50px',
			color: '#000',
			fontStyle: 'bold',
		},
		TEAMNAME: {
			fontFamily: 'Arial',
			fontSize: '30px',
			color: '#000',
			fontStyle: 'bold',
		},
		TEAMLEADERBOARD: {
			fontFamily: 'Arial',
			fontSize: '40px',
			color: '#000',
		},
		BUTTONSSTYLE: {
			fontFamily: 'Arial',
			fontSize: '32px',
			color: '#fff',
		},
		TITLECARDSTYLE: {
			fontFamily: 'Arial',
			fontSize: '25px',
			fontStyle: 'bold',
			color: '#000',
		},
		QUESTIONSTYLE: {
			fontFamily: 'Arial',
			fontSize: '15px',
			color: '#000',
		},
		TITLECARDSTYLEZOOMED: {
			fontFamily: 'Arial',
			fontSize: '32px',
			fontStyle: 'bold',
			color: '#000',
			wordWrap: {
				width: 700,
				height: 250,
			},
		},
		QUESTIONSTYLEZOOMED: {
			fontFamily: 'Arial',
			fontSize: '32px',
			color: '#000',
			wordWrap: {
				width: 700,
				height: 250,
			},
		},
		TIMERSTYLE: {
			fontFamily: 'Arial',
			fontSize: '25px',
			color: '#000',
			fontStyle: 'bold',
		},
		TIMERSTYLEMAGIC: {
			fontFamily: 'Arial',
			fontSize: '66px',
			color: '#000',
		},
		POINTS: {
			fontFamily: 'Arial',
			fontSize: '42px',
			color: '#000',
		},
	},
};
